export default "__VITE_ASSET__2c3ea33c__"